import { Routes, Route } from "react-router";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Views
import UnsubscribedContactsMain from "Modules/unsubscribedContacts/views/main";

const RouterUnsubscribedContacts = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "unsbctc") && <Route path="list" element={<UnsubscribedContactsMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterUnsubscribedContacts;